/*eslint no-extend-native: [0]*/
Promise.prototype.defaultIfDev =
	Promise.prototype.defaultIfDev ||
	function <T>(this: Promise<T>, data: T) {
		//With proxying this is more of a nuisance than anything
		return this;
	};
/*eslint no-extend-native: [0]*/
Promise.prototype.thenRun =
	Promise.prototype.thenRun ||
	function <T>(this: Promise<T>, func: (d: T) => void) {
		return this.then((data: any) => {
			func(data);
			return data;
		});
	};

/*eslint no-extend-native: [0]*/
Promise.prototype.catchThen =
	Promise.prototype.catchThen ||
	function <T, TError>(this: Promise<T>, func: (d: TError) => void) {
		this.catch(func);
		return this;
	};

//Just here so the compiler doesn't get miserable
export const a = "asdf";

declare global {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	interface Promise<T> {
		/** Catch on promise to resolve with default data if in dev mode */
		defaultIfDev<T>(this: Promise<T>, data: T): Promise<T>;
		/** Takes param A, executes function, then passes param A to next thing in promise */
		thenRun<T>(this: Promise<T>, func: (d: T) => void): Promise<T>;
		catchThen<T, TError>(this: Promise<T>, func: (d: TError) => void): Promise<T>;
	}
}
